const DEFAULT_SIZE = '1.875rem';

export type CustomIconProps = {
  width?: string | number;
  height?: string | number;
  size?: string | number;
};

const FanduelIcon = ({ width, height, size }: CustomIconProps) => {
  const resolved = size ?? width ?? height ?? DEFAULT_SIZE;
  const w = width ?? resolved;
  const h = height ?? resolved;

  return (
    <svg
      className="fanduel"
      width={w}
      height={h}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.05924 10.7523C7.92878 9.88461 9.89899 9.3573 11.8356 9.12721C12.0466 9.09844 12.1329 9.24226 12.1089 9.41003C11.8644 10.8961 11.6966 12.4061 11.6343 13.9305C11.6199 14.1031 11.5241 14.2181 11.3323 14.2565C10.2585 14.4674 9.2087 14.7982 8.05342 15.3255C9.09365 17.1327 10.3496 18.7865 11.735 20.1719C11.8932 20.3397 11.989 20.5122 12.0322 20.7951C12.3917 23.1152 13.0197 25.4545 13.8586 27.6692C13.9113 27.7939 13.9113 27.8802 13.8346 27.9521C13.7531 28.024 13.6333 28.024 13.5182 27.9521C5.14364 22.8468 0.0862866 13.6956 0 4.10341C0 3.87331 0.0814929 3.70074 0.273241 3.59048C4.72179 1.09776 9.72642 -0.100665 14.7502 0.00479594C14.9755 0.0143833 15.0522 0.206131 14.9659 0.388292C14.2708 1.8264 13.6956 3.29327 13.2402 4.75535C13.1875 4.92793 13.082 5.01421 12.8951 5.0238C10.2106 5.16282 7.59322 5.76682 5.19637 6.76391C5.36894 8.13012 5.66615 9.46277 6.05444 10.7523H6.05924ZM15.335 5.03818C15.1673 5.0238 15.0522 4.8704 15.1049 4.70742C15.6323 3.17822 16.2363 1.73053 16.9266 0.388292C17.008 0.2301 17.1423 0.162988 17.3292 0.186957C21.1115 0.613596 24.6923 1.80243 27.885 3.58569C28.0815 3.69594 28.1678 3.86852 28.1582 4.09862C28.0911 13.1827 23.5419 21.8784 15.8815 27.1323C15.7377 27.233 15.5508 27.1755 15.4836 27.0077C14.9276 25.5121 14.4722 23.9973 14.1462 22.5304C14.1031 22.3338 14.1462 22.1852 14.2996 22.0702C18.9351 18.4174 22.1852 12.967 22.9666 6.76391C20.6033 5.79079 18.0483 5.18199 15.335 5.03818Z"
        fill="white"
      />
    </svg>
  );
};

export default FanduelIcon;
